import MakeOffer from '../../src/legacy/MakeOffer';
export default MakeOffer;
